import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PropertyCardContext } from 'src/components/cards/property/property-card.context'
import { convertToMoney } from 'src/utils/monetary'

const DailyPrice = () => {
  const { property } = React.useContext(PropertyCardContext)
  const { t } = useTranslation('home-v2')

  const isUnavailable = property?.price?.daily?.grossAmount.amount === 0

  return (
    <Box>
      <Text fontSize="12px">{t('home-v2:PRODUCTS.night')}</Text>
      <Text
        textDecor={isUnavailable ? 'line-through' : 'none'}
        fontWeight="bold"
        fontSize="14px"
      >
        {convertToMoney(property?.price?.daily?.grossAmount)}
      </Text>
    </Box>
  )
}

export default DailyPrice
